import {
    buyApi,
    resultApi
} from "../../network/api";
const data = function () {
    return {
        yezf: false,
        ewmzf: false,
        ylzf: false,
        paytip: "",
        paypage: false,
        succ: false,
        saomab: false,
        pass: '',
        // saomaimg: require('../../assets/u=3249012985,3204939794&fm=15&gp=0.jpg'),
        saomaimg: '',
        http_url: "",
        order_id: "",
        pay_params: {},
    }
};
const computed = {}
const methods = {
    // 余额支付
    buy() {
        let formdata = {
            token: this.$store.state.userinfo.token,
            goods_id: this.$route.query.id,
            pay_type: 1,
            pwd: this.pass
        };
        buyApi(formdata)
            .then((res) => {
                console.log(res);
                if (res.data.code == 0) {
                    this.succ = true
                    this.$router.go(-1)
                } else {
                    this.$message({
                        message: res.data.msg
                    })
                }
            })
            .catch();
    },
    outlogin() {
        this.$router.push({
            path: '/index'
        })
    },
    yuezf() {
        this.paypage = true
        this.yezf = true
        this.ewmzf = false
        this.ylzf = false
    },
    saoma(e) {
        if (e == 2) {
            this.paypage = false
            this.saomab = true
            this.yezf = false
            this.ewmzf = true
            this.ylzf = false
            let formdata = {
                token: this.$store.state.userinfo.token,
                goods_id: this.$route.query.id,
                pay_type: e,
            };
            buyApi(formdata)
                .then((res) => {
                    console.log(res);

                    if (res.data.code == 2) {
                        var timer = ''
                        this.saomaimg = res.data.data.qrcode
                        let orderdata = {
                            token: this.$store.state.userinfo.token,
                            order_id: res.data.data.order_id,
                            type: 1,
                        };

                        timer = setInterval(() => {
                            resultApi(orderdata).then(res => {
                                console.log(res);
                                if (res.data.code == 0) {
                                    clearInterval(timer)
                                    this.$message({
                                        message: '支付成功',
                                        type: 'success'
                                    })
                                    setTimeout(() => {
                                        this.$router.go(-1)
                                    }, 500);
                                    return
                                }
                            })
                        }, 1000);

                    }
                    if (res.data.code == 1) {
                        this.$message({
                            message: res.data.msg
                        })
                    }

                })
                .catch();
        }
        if (e == 3) {
            this.paypage = false
            this.yezf = false
            this.ewmzf = false
            this.ylzf = true
            let formdata = {
                token: this.$store.state.userinfo.token,
                goods_id: this.$route.query.id,
                pay_type: e,
            };
            buyApi(formdata)
                .then((res) => {
                    console.log(res);
                    if (res.data.code == 2) {
                        this.http_url = res.data.data.http_url;
                        this.order_id = res.data.data.order_id;
                        this.pay_params = res.data.data.pay_params;
                    }
                })
            setTimeout(() => {
                this.$refs.form.submit()
            }, 500);
        }
    },
    goback() {
        this.$router.go(-1)
    }
}



export default {
    data,
    computed,
    methods,
}